import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import api from '../utils/api';
import './ReportOrderModal.css';

const REASON_OPTIONS = [
  { value: 'marked_delivered_not_received', label: 'Marked delivered but I did not receive the product' },
  { value: 'marked_paid_not_delivered', label: 'Marked paid / delivered but product was not delivered' },
  { value: 'wrong_items', label: 'Wrong or missing items' },
  { value: 'quality_issue', label: 'Quality issue with the product' },
  { value: 'other', label: 'Other' },
];

const ReportOrderModal = ({ orderId, orderNumber, onClose, onSuccess }) => {
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!reason || !description.trim()) {
      setError('Please select a reason and provide details.');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/reports', {
        orderId,
        reason,
        description: description.trim(),
      });
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit report. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="report-order-modal-overlay" onClick={onClose}>
      <div className="report-order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="report-order-modal-header">
          <h2>Report order issue</h2>
          <button type="button" className="report-order-modal-close" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>
        <p className="report-order-modal-hint">
          {orderNumber ? `Order #${orderNumber}` : `Order ID: ${orderId}`}. We will review your report and get back to you.
        </p>
        <form onSubmit={handleSubmit} className="report-order-modal-form">
          <label className="report-order-modal-label">
            Reason *
          </label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="report-order-modal-select"
            required
          >
            <option value="">Select a reason</option>
            {REASON_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <label className="report-order-modal-label">
            Details *
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="report-order-modal-textarea"
            placeholder="Describe what happened in detail..."
            rows={4}
            required
          />

          {error && <p className="report-order-modal-error">{error}</p>}

          <div className="report-order-modal-actions">
            <button type="button" className="report-order-modal-btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="report-order-modal-btn-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit report'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportOrderModal;
